import { useNavigation } from 'react-router-dom';

/**
 * Üst kenarda kayan ilerleme çubuğu. State'siz, CSS animation tabanlı:
 * - navigation aktifken kayan barı göster
 * - idle olunca hızlıca tamamla + sönsün
 */
export function RouteProgress() {
  const navigation = useNavigation();
  const isBusy = navigation.state !== 'idle';

  return (
    <div
      aria-hidden="true"
      data-busy={isBusy ? 'true' : 'false'}
      className="ds-route-progress"
    >
      <span className="ds-route-progress__bar" />
    </div>
  );
}
